import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ignored-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
    header: _ctx.$t('Squeeze.Prompts.ImportErrorHeader'),
    modal: true,
    onHide: _ctx.onClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: _ctx.$t('Squeeze.Prompts.IgnoreAll'),
        icon: "mdi mdi-cancel",
        class: "p-button-text",
        disabled: _ctx.allErrorsIgnored,
        onClick: _ctx.ignoreAllErrors
      }, null, 8, ["label", "disabled", "onClick"]),
      _createVNode(_component_Button, {
        label: _ctx.$t('Squeeze.General.Abort'),
        icon: "mdi mdi-close",
        class: "p-button-text",
        onClick: _ctx.onClose
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        label: _ctx.$t('Squeeze.Prompts.StartImport'),
        icon: "mdi mdi-check",
        class: "p-button-text",
        loading: _ctx.loading,
        disabled: !_ctx.allErrorsIgnored,
        onClick: _ctx.onConfirm
      }, null, 8, ["label", "loading", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Message, {
        severity: "warn",
        closable: false
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.Prompts.ImportErrorHint')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_DataTable, {
        value: _ctx.errors,
        class: "p-datatable-sm",
        autoLayout: true,
        scrollable: true,
        scrollHeight: "25rem",
        rowClass: _ctx.rowClass
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "prompt.fieldName",
            header: _ctx.$t('Squeeze.XmlMapper.FieldName'),
            class: "truncated-column",
            style: {"min-width":"9rem"}
          }, {
            body: _withCtx((slotProps) => [
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["column-cell", {'cell-error': _ctx.isMissing(slotProps.data, 'fieldName')}])
              }, [
                _createTextVNode(_toDisplayString(slotProps.data.prompt.fieldName), 1)
              ], 2)), [
                [
                  _directive_tooltip,
                  _ctx.getCellTooltip(slotProps.data, 'fieldName', slotProps.data.prompt.fieldName),
                  void 0,
                  { bottom: true }
                ]
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('Squeeze.XmlMapper.HeadData') + ' / ' + _ctx.$t('Squeeze.XmlMapper.PositionData'),
            style: {"min-width":"7rem"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.prompt.lineItem ? _ctx.$t('Squeeze.XmlMapper.PositionData') : _ctx.$t('Squeeze.XmlMapper.HeadData')), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('Squeeze.BatchClasses.BatchClass'),
            class: "truncated-column",
            style: {"min-width":"8rem"}
          }, {
            body: _withCtx((slotProps) => [
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["column-cell", {'cell-error': _ctx.isMissing(slotProps.data, 'batchClass')}])
              }, [
                _createTextVNode(_toDisplayString(slotProps.data.prompt.batchClass || '*'), 1)
              ], 2)), [
                [
                  _directive_tooltip,
                  _ctx.getCellTooltip(slotProps.data, 'batchClass', slotProps.data.prompt.batchClass),
                  void 0,
                  { bottom: true }
                ]
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('Squeeze.XmlMapper.DocumentClass'),
            class: "truncated-column",
            style: {"min-width":"8rem"}
          }, {
            body: _withCtx((slotProps) => [
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["column-cell", {'cell-error': _ctx.isMissing(slotProps.data, 'documentClass')}])
              }, [
                _createTextVNode(_toDisplayString(slotProps.data.prompt.documentClass || '*'), 1)
              ], 2)), [
                [
                  _directive_tooltip,
                  _ctx.getCellTooltip(slotProps.data, 'documentClass', slotProps.data.prompt.documentClass),
                  void 0,
                  { bottom: true }
                ]
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('Squeeze.XmlMapper.Company'),
            style: {"min-width":"7rem"}
          }, {
            body: _withCtx((slotProps) => [
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["column-cell", {'cell-error': _ctx.isMissing(slotProps.data, 'company')}])
              }, [
                _createTextVNode(_toDisplayString(slotProps.data.prompt.company || '*'), 1)
              ], 2)), [
                [
                  _directive_tooltip,
                  _ctx.getCellTooltip(slotProps.data, 'company', slotProps.data.prompt.company),
                  void 0,
                  { bottom: true }
                ]
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('Squeeze.Prompts.Creditor'),
            style: {"min-width":"7rem"}
          }, {
            body: _withCtx((slotProps) => [
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["column-cell", {'cell-error': _ctx.isMissing(slotProps.data, 'creditor')}])
              }, [
                _createTextVNode(_toDisplayString(slotProps.data.prompt.creditor || '*'), 1)
              ], 2)), [
                [
                  _directive_tooltip,
                  _ctx.getCellTooltip(slotProps.data, 'creditor', slotProps.data.prompt.creditor),
                  void 0,
                  { bottom: true }
                ]
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('Squeeze.Prompts.MissingReferences'),
            class: "references-column",
            style: {"min-width":"12rem"}
          }, {
            body: _withCtx((slotProps) => [
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["column-cell", {'cell-error': _ctx.hasReferenceWithoutColumn(slotProps.data)}])
              }, [
                _createTextVNode(_toDisplayString(_ctx.getMissingReferences(slotProps.data)), 1)
              ], 2)), [
                [
                  _directive_tooltip,
                  _ctx.getMissingReferences(slotProps.data),
                  void 0,
                  { bottom: true }
                ]
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, { style: {"min-width":"9rem","max-width":"9rem","text-align":"right"} }, {
            body: _withCtx((slotProps) => [
              (_ctx.isIgnored(slotProps.index))
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "mdi mdi-check" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Squeeze.Prompts.Ignored')), 1)
                  ]))
                : (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    label: _ctx.$t('Squeeze.Prompts.Ignore'),
                    icon: "mdi mdi-cancel",
                    class: "p-button-sm p-button-text p-button-danger",
                    onClick: ($event: any) => (_ctx.ignoreError(slotProps.index))
                  }, null, 8, ["label", "onClick"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "rowClass"])
    ]),
    _: 1
  }, 8, ["visible", "header", "onHide"]))
}